export const isTouchScreen = navigator.maxTouchPoints > 0;
export const isScreenLandscape = () => {
    if (window.screen.width > window.screen.height) {
        return true;
    } else {
        return false;
    }
}